<template>
  <div class="footer">
    <h4 data-aos="fade-up">Get in touch</h4>
    
      <p data-aos="fade-up">
        <a href="mailto:alex@alexwebb.me.uk" title="email">
          <font-awesome-icon icon="envelope"/>
        </a>
        <a href="https://www.linkedin.com/in/alex-webb-60938230/" target="_blank" title="linkedIn">
          <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'linkedin' }"/>
        </a>
        <a href="https://www.facebook.com/alex.webb.501598" target="_blank" title="facebook">
           <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }"/>
        </a>
      </p>

    <h6 data-aos="fade-up">Copywrite © {{ new Date().getFullYear() }} Alex Webb</h6>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  props: {
    
  }
}
</script>

<style scoped>
.footer{
  background-color: #222;
  color: #999;
  overflow: hidden;
  min-height: 400px;
}
a{
  font-size: 2em;
  margin: 30px;
  color: #999;
}
a:hover{
  color: #3782d2;
  animation-duration: 0.3s;
  animation-name: example;
}
@keyframes example {
  from {color: #999;}
  to {color: #3782d2;}
}
</style>
